import type { SVGProps } from "react"

import type { RoofEdgeType } from "@logic/lib/design"

export type SvgStrokeProps = Pick<
  SVGProps<SVGElement>,
  | `stroke`
  | `strokeDasharray`
  | `strokeLinecap`
  | `strokeLinejoin`
  | `strokeWidth`
>

export type StrokeFunction = (basis: number) => SvgStrokeProps

export const traceSolid = (basis: number): SvgStrokeProps => ({
  strokeDasharray: undefined,
  strokeWidth: basis,
})

export const traceDotted = (basis: number): SvgStrokeProps => ({
  strokeDasharray: `${basis}px, ${basis}px`,
  strokeWidth: basis,
})

export const traceDotDashThin = (basis: number): SvgStrokeProps => ({
  strokeDasharray: `${basis * 0.6}px, ${basis}px, ${basis * 3}px, ${basis}px`,
  strokeWidth: basis * 0.6,
})

export const traceDashThin = (basis: number): SvgStrokeProps => ({
  strokeDasharray: `${basis * 2}px, ${basis}px`,
  strokeWidth: basis * 0.6,
})

export const traceStitchThin = (basis: number): SvgStrokeProps => ({
  strokeDasharray: `${basis * 0.6}px, ${basis * 2}px`,
  strokeWidth: basis * 2,
})

export type EdgeAppearance = {
  trace: StrokeFunction
  color: string
}

export const COLOR = {
  PURPLE: `#7000FF`,
  RED: `#F10303`,
  BLUE: `#00A0FF`,
  GREEN: `#00BC29`,
  PINK: `#FF00F5`,
}

export const EDGE_APPEARANCES: Record<RoofEdgeType, EdgeAppearance> = {
  eave: {
    trace: traceSolid,
    color: COLOR.PURPLE,
  },
  ridge: {
    trace: traceDotted,
    color: COLOR.RED,
  },
  rake: {
    trace: traceDotDashThin,
    color: COLOR.BLUE,
  },
  hip: {
    trace: traceDashThin,
    color: COLOR.GREEN,
  },
  valley: {
    trace: traceStitchThin,
    color: COLOR.PINK,
  },
}
